export default __webpack_public_path__ + "fonts/arrow-up-blue.svg";